"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// wait util will wait specified amount of time in milliseconds
const wait = async (timeoutMs) => {
    return new Promise(resolve => setTimeout(() => resolve(null), timeoutMs));
};
exports.default = wait;
